import {
  getDashboardReportTypes,
  getSummaryParvandeh,
  getCompetencyWashupScores,
  getDashboardReport,
  summaryParvandehExport,
} from "./dashboard-services";

export {
  getDashboardReportTypes,
  getSummaryParvandeh,
  getCompetencyWashupScores,
  getDashboardReport,
  summaryParvandehExport,
};
